import { useIsArticlePage } from "@src/app/hooks/useIsArticlePage";
import { useRouteResponse } from "@src/app/hooks/useRouteResponse";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";

import { isRealSection } from "../types/Data";
import { useCustomParams } from "./useCustomParams";
import useGTMDispatch from "./useGTMDispatch";

/**
 * @see https://docs.google.com/spreadsheets/d/1q0SgHX5VxmNnquJKg6ARxf36y1_pwhiC2dgxX2Gn-wc/edit?gid=0#gid=0
 * @see https://github.dev/SPHTech/thinkchina-web2/blob/main/src/app/utils/getArticleCardDataFromSearchHits.ts
 */
export default function useGAData() {
  const { level1 = "", level2 = "" } = useCustomParams();

  const isArticlePage = useIsArticlePage();
  const { article } = useRouteResponse("articlePage");
  const { author: contributor } = useRouteResponse("authorPage");
  const { sectionName = "" } = useRouteResponse("sectionPage");
  const { tagName = "" } = useRouteResponse("keywordPage");

  const contenttype = isArticlePage ? "article" : "index/listing page";
  const keyword = isArticlePage
    ? (article?.tags || []).map((i) => i.name).join(", ")
    : "";
  const author = isArticlePage
    ? article?.authors.map((i) => i.name).join(", ") || ""
    : "";
  const contentcat = "free";
  const articleid = isArticlePage ? article?.id || "" : "";
  const pubdate = isArticlePage
    ? article?.created
      ? dayjs(article.created).format("YYYY-MM-DD HH:mm:ss")
      : ""
    : "";
  const cd_version = "tc2";
  const visitorcat = "anonymous";

  const [searchParams] = useSearchParams();
  const pagination = +(searchParams.get("page") || "") || 1; //

  const title = isArticlePage
    ? article?.title || ""
    : level1 == "tags"
      ? tagName
      : isRealSection(level1)
        ? sectionName
        : {
            "about-us": "About Us",
            contributors: level2 ? contributor?.name || "" : "Contributors", // contributor page - Contributor Name while Contributors listing page - "Contributors"
            newsletter: "Newsletter",
            search: "Search",
          }[level1] || "";

  const [isLoaded, setIsLoaded] = useState(false);
  const sendDataToGTM = useGTMDispatch();

  useEffect(() => {
    if (isLoaded) return;
    sendDataToGTM({
      event: "tcCustomPageView",
      articleid,
      cue_articleid: articleid,
      author,
      cd_version,
      level2: level1 || "home",
      chapter1: level2,
      contentcat,
      contenttype,
      keyword,
      pubdate,
      title,
      visitorcat: visitorcat,
      at: "",
    });
    setIsLoaded(true);
  }, [
    isLoaded,
    sendDataToGTM,
    articleid,
    author,
    cd_version,
    level1,
    level2,
    contentcat,
    contenttype,
    keyword,
    pubdate,
    title,
    visitorcat,
  ]);

  return {
    articleid,
    cue_articleid: articleid,
    at: "", //  mysphw cookie
    author, // Comma separated author name
    chapter1: level2 || "", // Section child category name.
    contentcat, // Paid (2) or free (1)
    contenttype, // index/listing, article
    keyword, // Comma separated keyword names
    level2: level1 || "home",
    pagination,
    page: pagination,
    pubdate,
    title,
    visitorcat,
    cd_version,
  };
}
